// extracted by mini-css-extract-plugin
module.exports = {"head":"IconCard_head__gVppo","heading":"IconCard_heading__5gmjF"};